var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"app-back",on:{"click":function($event){$event.preventDefault();return _vm.back($event)}}},[_c('i',{staticClass:"sappfont sappfont-arrow-left is-size-4"})])}
var staticRenderFns = []

export { render, staticRenderFns }